const TabButton = ({ label, active, onClick }) => (
    <button
        onClick={onClick}
        className={`px-4 py-2 rounded-lg transition-colors ${active
            ? 'bg-purple-600/20 text-purple-400'
            : 'text-gray-400 hover:bg-purple-600/10'
            }`}
    >
        {label}
    </button>
);

export default TabButton;